import { useGdprTextsStore } from '../../stores/gdpr-texts-store';
import { usePayloadStore } from '../../stores/payload-store';

export default async function fetchGdprTexts() {
    const payload = usePayloadStore();
    const gdprTexts = useGdprTextsStore();

    if (payload.exists && !gdprTexts.fetched) {
        // Fetch gdpr texts if we have a payload & we don't have them already.
        await gdprTexts.getTexts(payload.atsUserUuid, payload.encryptedPayload);
    }
}
